import Popover from '@material-ui/core/Popover'
import Paper from '@material-ui/core/Paper'
import { ContainerTitle } from '../../../../../../common/container-title'
import { FunctionDataPopperContent } from './function-data-popper-content'
import { Grid } from '@material-ui/core'
import { AddItemButtons } from '../../../../../../conventions-collectives/themes/add-item-buttons'
import React from 'react'

export const FonctionPopperDefinition = ({
  anchorEl,
  nom,
  currentTags,
  open,
  classes,
  setAnchorEl,
  currentType,
  excludeFonctions,
  line,
  fonctionParams,
  setFonctionParams,
}) => {
  return (
    <Popover
      anchorEl={anchorEl}
      id={'pop_' + nom}
      open={open}
      anchorOrigin={{
        vertical: 'center',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'center',
        horizontal: 'right',
      }}
    >
      {open && (
        <Paper className={classes.popper} elevation={1}>
          <ContainerTitle variant="h5" classes={classes} title={'Valeur de ' + nom} />
          <FunctionDataPopperContent
            nom={nom}
            currentTags={currentTags}
            className={classes.formControl}
            classes={classes}
            currentType={currentType}
            excludeFonctions={excludeFonctions}
            line={line}
            setAnchorEl={setAnchorEl}
            fonctionParams={fonctionParams}
            setFonctionParams={setFonctionParams}
          />
        </Paper>
      )}
    </Popover>
  )
}
